module.exports = __webpack_public_path__ + "img/horizontal_6_3_8011.a7cdb1b9.png";